import BrandArticle from "@/pages/article/components/BrandArticle";
import { brandArticles } from "@/mocks/brandArticles";

const data = brandArticles.find((a) => a.slug === "allchinabuy-spreadsheet")!;

export default function AllChinaBuySpreadsheetPage() {
  return <BrandArticle data={data} />;
}